module.exports = __webpack_public_path__ + "static/media/SF_bm_sentrert_logo_innlandet_pos.0575ea14.pdf";